import * as Yup from "yup";

import moment from "moment";
import { useIntl } from "react-intl";
import { validateNumericOrEmptyString } from "../../../../../../../util/validators/yupValidators";

export default function useServiceValuationFormValidation() {
  const { formatMessage } = useIntl();

  const validationSchema = Yup.object({
    Codigo_postal: Yup.string().required(
      formatMessage({
        id: "ValuationForm.Código postal obligatorio",
        defaultMessage: "Código postal obligatorio",
      })
    ),
    Ciudad: Yup.object()
      .nullable()
      .required(
        formatMessage({
          id: "ValuationForm.La ciudad es obligatoria. Intenta poner un código postal válido.",
          defaultMessage:
            "La ciudad es obligatoria. Intenta poner un código postal válido.",
        })
      )
      .shape({
        value: Yup.string().required(
          formatMessage({
            id: "ValuationForm.La ciudad es obligatoria. Intenta poner un código postal válido.",
            defaultMessage:
              "La ciudad es obligatoria. Intenta poner un código postal válido.",
          })
        ),
      }),
    Region: Yup.object()
      .nullable()
      .required(
        formatMessage({
          id: "ValuationForm.La región es obligatoria. Intenta poner un código postal válido.",
          defaultMessage:
            "La región es obligatoria. Intenta poner un código postal válido.",
        })
      )
      .shape({
        value: Yup.string().required(
          formatMessage({
            id: "ValuationForm.La región es obligatoria. Intenta poner un código postal válido.",
            defaultMessage:
              "La región es obligatoria. Intenta poner un código postal válido.",
          })
        ),
      }),
    Nombre_U1: Yup.string().required(
      formatMessage({
        id: "ValuationForm.NameRequired",
        defaultMessage: "El nombre es obligatorio",
      })
    ),
    Primer_apellido_U1: Yup.string().required(
      formatMessage({
        id: "ValuationForm.SurnameRequired",
        defaultMessage: "El primer apellido es obligatorio",
      })
    ),
    Fecha_de_nacimiento_U1: Yup.mixed().test(
      "valid_date",
      formatMessage({
        id: "ValuationForm.BirthdateNotValid",
        defaultMessage: "La fecha de nacimiento ha de ser válida",
      }),
      (value) => {
        const momDate = moment(value);
        if (momDate.isValid()) {
          return true;
        }
        return false;
      }
    ),
    Grado_Ley_de_dependencia_U1: Yup.object()
      .nullable()
      .required(
        formatMessage({
          id: "ValuationForm.El grado de dependencia para el usuario 1 es obligatorio",
          defaultMessage:
            "El grado de dependencia para el usuario 1 es obligatorio",
        })
      )
      .shape({
        value: Yup.string().required(
          formatMessage({
            id: "ValuationForm.El grado de dependencia para el usuario 1 es obligatorio",
            defaultMessage:
              "El grado de dependencia para el usuario 1 es obligatorio",
          })
        ),
      }),
    Patologias_U1: Yup.array().min(
      1,
      formatMessage({
        id: "ValuationForm.Min1Pathology",
        defaultMessage: "Debes incluir las patologías del usuario",
      })
    ),
    Peso_U1: Yup.string().test(
      "numericString",
      formatMessage({
        id: "ValuationForm.El peso del primer usuario debe ser un número entero",
        defaultMessage: "El peso del primer usuario debe ser un número entero",
      }),
      validateNumericOrEmptyString
    ),
    Altura_U1: Yup.string().test(
      "numericString",
      formatMessage({
        id: "ValuationForm.La altura del primer usuario debe ser un número entero",
        defaultMessage:
          "La altura del primer usuario debe ser un número entero",
      }),
      validateNumericOrEmptyString
    ),
    Movilidad_U1: Yup.array().min(
      1,
      formatMessage({
        id: "ValuationForm.MovilityRequired",
        defaultMessage: "Debes especificar la movilidad del usuario",
      })
    ),
    Adaptaci_n_de_cuidados_U1: Yup.string().required(
      formatMessage({
        id: "ValuationForm.CaretakerAdaptationRequired",
        defaultMessage: "Debes indicar la adaptación a cuidados",
      })
    ),

    Nombre_U2: Yup.string().when("Usuarios_a_cuidar", {
      is: "2",
      then: Yup.string().required(
        formatMessage({
          id: "ValuationForm.NameRequired2",
          defaultMessage: "El nombre de U2 es obligatorio",
        })
      ),
    }),
    Primer_apellido_U2: Yup.string().when("Usuarios_a_cuidar", {
      is: "2",
      then: Yup.string().required(
        formatMessage({
          id: "ValuationForm.SurnameRequired2",
          defaultMessage: "El primer apellido de U2 es obligatorio",
        })
      ),
    }),
    Grado_Ley_de_dependencia_U2: Yup.mixed().when("Usuarios_a_cuidar", {
      is: "2",
      then: Yup.object()
        .nullable()
        .required(
          formatMessage({
            id: "ValuationForm.El grado de dependencia para el usuario 2 es obligatorio",
            defaultMessage:
              "El grado de dependencia para el usuario 2 es obligatorio",
          })
        )
        .shape({
          value: Yup.string().required(
            formatMessage({
              id: "ValuationForm.El grado de dependencia para el usuario 2 es obligatorio",
              defaultMessage:
                "El grado de dependencia para el usuario 2 es obligatorio",
            })
          ),
        }),
    }),
    Fecha_de_nacimiento_U2: Yup.mixed().when("Usuarios_a_cuidar", {
      is: "2",
      then: Yup.mixed().test(
        "valid_date",
        formatMessage({
          id: "ValuationForm.Birthdate2NotValid",
          defaultMessage: "La fecha de nacimiento de U2 ha de ser válida",
        }),
        (value) => {
          const momDate = moment(value);
          if (momDate.isValid()) {
            return true;
          }
          return false;
        }
      ),
    }),
    Patologias_U2: Yup.array().when("Usuarios_a_cuidar", {
      is: "2",
      then: Yup.array().min(
        1,
        formatMessage({
          id: "ValuationForm.Min1Pathology2",
          defaultMessage: "Debes incluir las patologías del usuario U2",
        })
      ),
    }),
    Peso_U2: Yup.string().when("Usuarios_a_cuidar", {
      is: "2",
      then: Yup.string().test(
        "numericString",
        formatMessage({
          id: "ValuationForm.El peso del segundo usuario debe ser un número entero",
          defaultMessage:
            "El peso del segundo usuario debe ser un número entero",
        }),
        validateNumericOrEmptyString
      ),
    }),
    Altura_U2: Yup.string().when("Usuarios_a_cuidar", {
      is: "2",
      then: Yup.string().test(
        "numericString",
        formatMessage({
          id: "ValuationForm.La altura del segundo usuario debe ser un número entero",
          defaultMessage:
            "La altura del segundo usuario debe ser un número entero",
        }),
        validateNumericOrEmptyString
      ),
    }),
    Movilidad_U2: Yup.array().when("Usuarios_a_cuidar", {
      is: "2",
      then: Yup.array().min(
        1,
        formatMessage({
          id: "ValuationForm.MovilityRequired2",
          defaultMessage: "Debes especificar la movilidad del usuario U2",
        })
      ),
    }),
    Adaptaci_n_de_cuidados_U2: Yup.string().when("Usuarios_a_cuidar", {
      is: "2",
      then: Yup.string().required(
        formatMessage({
          id: "ValuationForm.CaretakerAdaptationRequired2",
          defaultMessage: "Debes indicar la adaptación a cuidados de U2",
        })
      ),
    }),

    Tipo_de_vivienda: Yup.string().required(
      formatMessage({
        id: "ValuationForm.HomeTypeRequired",
        defaultMessage: "Debes indicar el tipo de vivienda",
      })
    ),

    Tareas_solicitadas: Yup.array().when("service_type", {
      is: "Seleccion",
      then: Yup.array().min(
        1,
        formatMessage({
          id: "ValuationForm.TasksRequired",
          defaultMessage: "Debes indicar las tareas solicitadas",
        })
      ),
    }),
    Sexo_trabajador: Yup.string().when("service_type", {
      is: "Seleccion",
      then: Yup.string().required(
        formatMessage({
          id: "ValuationForm.CaretakerGenderRequired",
          defaultMessage: "Debes indicar el sexo del trabajador",
        })
      ),
    }),
    Horario_Servicio: Yup.string().when("service_type", {
      is: "Seleccion",
      then: Yup.string().required(
        formatMessage({
          id: "ValuationForm.Debes introducir el horario",
          defaultMessage: "Debes introducir el horario",
        })
      ),
    }),
    Salario_Bruto: Yup.string().when("service_type", {
      is: "Seleccion",
      then: Yup.string().required(
        formatMessage({
          id: "ValuationForm.Debes introducir el salario",
          defaultMessage: "Debes introducir el salario",
        })
      ),
    }),
    Horas_jornada_semanal: Yup.string().when("service_type", {
      is: "Seleccion",
      then: Yup.string().required(
        formatMessage({
          id: "ValuationForm.Debes introducir la jornada semanal",
          defaultMessage: "Debes introducir la jornada semanal",
        })
      ),
    }),
    Descanso_semanal: Yup.string().when("service_type", {
      is: "Seleccion",
      then: Yup.string().required(
        formatMessage({
          id: "ValuationForm.Debes introducir el descanso semanal",
          defaultMessage: "Debes introducir el descanso semanal",
        })
      ),
    }),
    Cl_usulas_especiales: Yup.string().when("service_type", {
      is: "Seleccion",
      then: Yup.string().required(
        formatMessage({
          id: "ValuationForm.Debes introducir las cláusulas especiales",
          defaultMessage: "Debes introducir las cláusulas especiales",
        })
      ),
    }),
    Fecha_objetivo: Yup.mixed().when("service_type", {
      is: "Seleccion",
      then: Yup.mixed().test(
        "valid_date",
        formatMessage({
          id: "ValuationForm.TargetDateValid",
          defaultMessage: "La fecha objetivo ha de ser válida",
        }),
        (value) => {
          const momDate = moment(value);
          if (momDate.isValid()) {
            return true;
          }
          return false;
        }
      ),
    }),
  });

  return validationSchema;
}
